// eslint-disable-next-line no-unused-vars
import ChatRepository from '../../../domain/repositories/ChatRepository';
// eslint-disable-next-line no-unused-vars
import Message from '../../../domain/entities/Message';

class SendMessageUseCase {
    /**
     * @param {ChatRepository} chatRepository
     */
    constructor(chatRepository) {
        this.chatRepository = chatRepository;
    }

    /**
     * Sends a new message to a conversation.
     * @param {string} conversationId
     * @param {string} senderId
     * @param {string} senderName
     * @param {string} messageText
     * @param {string} type - 'text' or 'image'
     * @param {File} [imageFile] - The image file to upload if type is 'image'.
     * @returns {Promise<Message>}
     */
    async execute(conversationId, senderId, senderName, messageText, type = 'text', imageFile = null) {
        return this.chatRepository.sendMessage(conversationId, senderId, senderName, messageText, type, imageFile);
    }
}

export default SendMessageUseCase;
